import { inject, Injectable } from '@angular/core';

import { RedirectService } from './redirect.service';

const CHAVE = 'customUrlRedirect';

/**
 * Guarda o endereço personalizado por onde a pessoa entrou.
 *
 * A volta do provedor externo é carga de página inteira numa URL fixa (`/{cidade}/callback`), então
 * nada da query da tela de login sobrevive à viagem. Sem esta memória, o botão de voltar perde a
 * origem no meio do fluxo e manda a pessoa para o endereço antigo (APR-3364).
 */
@Injectable({ providedIn: 'root' })
export class CustomUrlRedirectStore {
  private readonly _redirect = inject(RedirectService);

  /** Guarda e devolve o endereço, ou devolve vazio quando não há o que guardar. */
  remember(cityIdentity: string, url?: string): string {
    if (!url || !this._redirect.isAllowedDomain(url)) return '';

    try {
      sessionStorage.setItem(CHAVE, JSON.stringify({ cityIdentity, url }));
    } catch {
      // Aba anônima ou storage cheio: degrada para o comportamento sem memória.
    }

    return url;
  }

  recall(cityIdentity: string): string {
    try {
      const bruto = sessionStorage.getItem(CHAVE);
      if (!bruto) return '';

      const { cityIdentity: cidade, url } = JSON.parse(bruto) ?? {};

      // Amarrado à cidade: trocar de cidade na mesma aba não pode herdar a origem da anterior.
      if (cidade !== cityIdentity || typeof url !== 'string') return '';

      // Revalidado na leitura: o storage é da origem inteira, não só desta tela.
      return this._redirect.isAllowedDomain(url) ? url : '';
    } catch {
      return '';
    }
  }
}
